import React, { PureComponent } from 'react';
import { withStyles, Paper, Table, TableHead, TableBody, TableRow, TableCell, 
  Toolbar, Typography, TextField, Checkbox} from '@material-ui/core';
import { format } from 'date-fns';
import PropTypes from 'prop-types';

const styles = theme => ({
  root: {
    maxWidth: 1060,
    margin: 'auto',
  },
  toolbar: {
    paddingRight: theme.spacing.unit,
  },
  spacer: {
    flexGrow: 1,
  },
  title: {
    flex: '0 0 auto',
  },
  tablerow: {
    height: 36
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 150,
  },
});

class SeasonsList extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      userIsAdmin: false,
    };
  }

  componentDidMount() {
    const token = localStorage.getItem('kodaro-token');
    // Determine if the logged in user is an admin
    const decodedToken = token ? atob(token.split(".")[1]) : null;
    const parsedToken = decodedToken ? JSON.parse(decodedToken) : null;
    this.setState({ userIsAdmin: parsedToken.userType === "Admin" });
    const { getAllSeasons } = this.props;
    getAllSeasons();
  }

  handleMaxDateChange = event => {
    const { id, value } = event.target;
    const { updateSeasonMaxDate } = this.props;

    updateSeasonMaxDate(id, value);
  }

  handleActiveChange = (event) => {
    const { id, checked } = event.target;
    const { updateSeasonActive } = this.props;

    updateSeasonActive(id, checked);
  }

  handleDisplayChange = (event) => {
    const { id, checked } = event.target;
    const { updateSeasonDisplay } = this.props;
    updateSeasonDisplay(id, checked);
  }

  render() {
    const { classes } = this.props;
    return (
      <Paper className={classes.root}>
        <Toolbar className={classes.toolbar}>
          <div  className={classes.title}>
            <Typography variant="h5">Season Table</Typography>
          </div>
          <div className={classes.spacer} />
        </Toolbar>
        <Table padding="none">
          <TableHead>
            <TableRow>
              <TableCell align="center"><Typography variant="body1">Season ID</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body1">Season</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body1">Season Group</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body1">Active</Typography></TableCell>
              <TableCell align="center"><Typography variant="body1">Display</Typography></TableCell>
              <TableCell align="center"><Typography variant="body1">Start - Finish</Typography></TableCell>
              <TableCell align="center"><Typography variant="body1">Max Schedule Date</Typography></TableCell>
            </TableRow>
          </TableHead>
          {this.renderTableBody()}
        </Table>
      </Paper>
      );
    }

  renderTableBody() {
    const { classes, allSeasons, allSeasonsList } = this.props;
    return (
    <TableBody>
        {allSeasonsList.map(id => {
          return (
            <TableRow className={classes.tablerow} key={`${id}`} hover>
              <TableCell align="center"><Typography variant="body1">{allSeasons[id].seasonId}</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body1">{allSeasons[id].name}</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body1">{allSeasons[allSeasons[id].parentSeasonId].name}</Typography></TableCell>
              <TableCell align="center">
                <Checkbox
                  id={id}
                  checked={allSeasons[id].active}
                  onChange={this.handleActiveChange}
                  disabled={!this.state.userIsAdmin}
                />
              </TableCell>
              <TableCell align="center">
                <Checkbox
                  id={id}
                  checked={allSeasons[id].display}
                  onChange={this.handleDisplayChange}
                  disabled={!this.state.userIsAdmin}
                />
              </TableCell>
              <TableCell align="center"><Typography variant="body1">
                {format(allSeasons[id].start, 'MM/DD/YYYY')} - {format(allSeasons[id].finish, 'MM/DD/YYYY')}
              </Typography></TableCell>
              <TableCell align="center">
                <TextField
                  className={classes.textField}
                  id={id}
                  type="date"
                  value={format(allSeasons[id].maxScheduleDate, 'YYYY-MM-DD')}
                  onChange={this.handleMaxDateChange}
                />
              </TableCell>
            </TableRow>
          );
      })}
      </TableBody>
    );
  }
}

SeasonsList.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(SeasonsList);



// WEBPACK FOOTER //
// ./src/components/lists/SeasonsList.js